import React, { useState, useEffect } from 'react';
import { useForm } from 'react-hook-form';
import { Button, Card, CardBody, CardHeader, FormGroup, Form, Input, Row, Col, Spinner } from "reactstrap";
import moment from "moment";
import Select from 'react-select'

import DatePicker, { registerLocale } from "react-datepicker";
import pt from 'date-fns/locale/pt-BR'; // importa o locale pt-BR do date-fns
import { startOfMonth } from "date-fns"; // importa a função startOfMonth do date-fns
import "react-datepicker/dist/react-datepicker.css";

// services
import indiceiqg_api from '../../api/indiceiqg_api';
import impressaodocumento_api from '../../api/impressaodocumento_api';
import concessionaria_api from '../../api/concessionaria_api';
import contrato_api from '../../api/contrato_api';

// helpers
import { showMessage } from '../../helpers/message';
import { useReactToPrint } from 'react-to-print';
import { useRef } from 'react';
import PrintFooter from '../../components/PrintFooter/PrintFooter';

// registra o locale pt-BR para ser usado pelo DatePicker
registerLocale('pt', pt);

export default function ConsultaIQG() {
    const { register, handleSubmit, errors, setValue, watch } = useForm({
        mode: "onBlur", defaultValues: {
            mesAno: startOfMonth(new Date())
        }
    });
    const [showLoading, setshowLoading] = useState(false);
    const [relatorioIQG, setRelatorioIQG] = useState(null);

    useEffect(() => {
        loadOptionsConcessionarias();
    }, []);

    const selectedDate = watch("mesAno"); // pega o valor selecionado do campo mesAno

    // Concessionária
    const [options_concessionaria, set_options_concessionaria] = useState([]);
    const loadOptionsConcessionarias = () => {
        concessionaria_api.getByUsuarioId().then(result => {
            if (result.status !== 200) {
                showMessage("Aviso", result.message, 'error', null);
                return;
            }
            else {
                set_options_concessionaria(result.data);
            }
        })
    }

    const handleChange = (date) => {
        console.log(date);
        setValue("mesAno", date, { shouldValidate: true });
    }

    const onSubmit = (data) => {
        const mesAno = moment(data.mesAno).format("MM/YYYY");
        const { concessionaria_Id } = concessionaria;
        const { contrato_Id } = contrato;

        setshowLoading(true);
        indiceiqg_api.PostRelatorioIQG({ mesAno, concessionaria_Id, contrato_Id }).then(result => {
            setshowLoading(false);
            if (result.status !== 200) {
                showMessage("Aviso", result.message, 'error', null);
            }
            else {
                if (result.data && result.data.length === 0) {
                    showMessage("Aviso", "Índice não foi calculado para o período informado.", 'warning', null);
                    return;
                }
                setRelatorioIQG(result.data);
            }
        })
    }

    const [concessionaria, set_concessionaria] = useState("");
    const handleChangeConcessionaria = (value) => {
        set_concessionaria(value);
        setValue("concessionaria", value, true);
        set_contrato(null);
        setValue("contrato", null, true);
        loadContratos(value.concessionaria_Id);
    }

    //Contratos
    const [options_contrato, set_options_contrato] = useState([]);
    const loadContratos = (concessionaria_Id) => {
        contrato_api.getAll(concessionaria_Id).then(result => {
            if (result.status !== 200) {
                showMessage("Aviso", result.message, 'error', null);
                return;
            }
            else {
                set_options_contrato(result.data);
            }
        })
    }

    const [contrato, set_contrato] = useState("");
    const handleChangeContrato = (value) => {
        set_contrato(value);
        setValue("contrato", value, true);
    }

    const componentRef = useRef();
    const handlePrint = useReactToPrint({
        content: () => componentRef.current,
        copyStyles: true,
        documentTitle: `${concessionaria.identificacao}_RelatórioIQG`
    });

    const handlePrintComHash = async () => {
        try {
            const conteudo = componentRef.current?.innerText || '';
            // Captura o texto do rodapé (PrintFooter) dentro do componente
            const rodapeEl = componentRef.current?.querySelector('.print-footer');
            const rodape = rodapeEl?.innerText || '';

            const result = await impressaodocumento_api.postHashRelatorio({ conteudo, rodape });
            if (result.status !== 200) {
                showMessage('Aviso', result.data?.message || 'Erro ao registrar impressão.', 'error', null);
                return;
            }
            handlePrint();
        } catch (e) {
            showMessage('Erro', 'Não foi possível registrar a impressão no servidor.', 'error', null);
        }
    };
    return <>
        {showLoading &&
            <div className="carregandoCmp">
                <div className="box">
                    <Spinner></Spinner>
                </div>
            </div>
        }
        <div className='content'>
            <Row className="d-flex align-items-center">
                <Col md="12">
                    <Card className="my-4">
                        <CardHeader>
                            <div className='d-flex justify-content-between align-items-center'>
                                <h4 className="titleCard">Relatório de IQG</h4>
                                {relatorioIQG && relatorioIQG.length > 0 &&
                                    <Button
                                        color="danger" onClick={handlePrintComHash}>
                                        <i className="fas fa-print mr-2"></i>
                                        Imprimir
                                    </Button>
                                }
                            </div>
                        </CardHeader>
                        <CardBody>
                            <Form onSubmit={handleSubmit(onSubmit)}>
                                <Row className="mb-1 align-items-end">
                                    <Col lg="4" md="12" sm="12">
                                        <FormGroup>
                                            <label className="form-control-label">Concessionária</label>
                                            <Select
                                                name="concessionaria"
                                                options={options_concessionaria}
                                                getOptionLabel={o => o.identificacao}
                                                getOptionValue={o => o.concessionaria_Id}
                                                value={concessionaria}
                                                onChange={(o) => handleChangeConcessionaria(o)}
                                                classNamePrefix="select"
                                                placeholder="[ Selecione ]"
                                                ref={e => register(
                                                    { name: "concessionaria" },
                                                    { required: true })
                                                }
                                            />
                                            {errors.concessionaria && <span className='text-danger'>Campo obrigatório</span>}
                                        </FormGroup>
                                    </Col>
                                    <Col lg="8" md="12" sm="12">
                                        <FormGroup>
                                            <label className="form-control-label">Contrato</label>
                                            <Select
                                                name="contrato"
                                                options={options_contrato}
                                                getOptionLabel={o => o.identificacao}
                                                getOptionValue={o => o.contrato_Id}
                                                value={contrato}
                                                onChange={(o) => handleChangeContrato(o)}
                                                classNamePrefix="select"
                                                placeholder="[ Selecione ]"
                                                ref={e => register(
                                                    { name: "contrato" },
                                                    { required: true })
                                                }
                                            />
                                            {errors.contrato && <span className='text-danger'>Campo obrigatório</span>}
                                        </FormGroup>
                                    </Col>
                                    <Col lg="3" md="3" sm="3">
                                        <FormGroup>
                                            <label className="form-control-label">Selecione o período</label>
                                            <DatePicker
                                                className="form-control text-md-right"
                                                dateFormat={"MM/yyyy"}
                                                showMonthYearPicker
                                                showFullMonthYearPicker
                                                locale={"pt"}
                                                name="mesAno"
                                                selected={selectedDate}
                                                onChange={date => handleChange(date)}
                                                ref={e => register(
                                                    { name: "mesAno" },
                                                    { required: true }
                                                )}
                                            />
                                            {errors.mesAno && <span className='text-danger'>Campo obrigatório</span>}
                                        </FormGroup>
                                    </Col>
                                    <Col>
                                        <Button color="info" type="submit">
                                            <i className="fas fa-search mr-2"></i>
                                            Pesquisar
                                        </Button>
                                    </Col>
                                </Row>
                                {relatorioIQG && relatorioIQG.length > 0 &&
                                    <ComponentToPrint ref={componentRef} relatorioIQG={relatorioIQG} concessionaria={concessionaria} mesAno={moment(selectedDate).format("MM/YYYY")} />
                                }
                            </Form>
                        </CardBody>
                    </Card>
                </Col>
            </Row>
        </div>
    </>;
}

export const ComponentToPrint = React.forwardRef((props, ref) => {
    const relatorioIQG = props.relatorioIQG;
    const concessionaria = props.concessionaria;
    const mesAno = props.mesAno;

    const colors = {
        "Ótimo": "#3498db",
        "Boa": "#2980b9",
        "Regular": "#2ecc71 ",
        "Ruim": " #f1c40f ",
        "Péssimo": "#e67e22"
    }
    const handleIndicadorQualidadeServico = (date) => {
        if (date >= 95 && date <= 100)
            return "Ótimo"
        else if (date >= 80 && date < 95)
            return "Boa"
        else if (date >= 60 && date < 80)
            return "Regular"
        else if (date >= 40 && date < 60)
            return "Ruim"
        else if (date < 40)
            return "Péssimo"
    }

    return (
        <>
            {relatorioIQG && relatorioIQG.length > 0 &&
                <div ref={ref} className='mb-2'>
                    <Row >
                        <Col lg="12" md="12" sm="12" className="mt-3">
                            <h3 className="m-0 text-center">Qualificação Global da Concessionária</h3>
                            <h5 className="mb-2 titleCard text-center">{concessionaria.identificacao} - {mesAno}</h5>
                        </Col>
                        <Col>
                            <table border="1" style={{
                                width: "100%",
                                padding: "30px"
                            }}>
                                {/* th */}
                                <thead>
                                    <tr>
                                        <th colSpan={3} rowSpan={3} style={{ padding: "8px 8px 0px 8px" }}>
                                            Índices
                                            <div className='d-flex align-items-center justify-content-end m-1'>
                                                Pesos
                                            </div>
                                        </th>
                                        <th colSpan={3} rowSpan={3} style={{ padding: "8px 8px 0px 8px" }}>
                                            Sub-Índices
                                            <div className='d-flex align-items-center justify-content-end m-1'>
                                                Pesos
                                            </div>
                                        </th>
                                        <th colSpan={3} rowSpan={3} style={{ padding: "8px 8px 0px 8px" }}>
                                            Indicadores
                                            <div className='d-flex align-items-center justify-content-end m-1'>
                                                Pesos
                                            </div>
                                        </th>
                                        <th colSpan={5} style={{ padding: "8px 8px 0px 8px" }}>
                                            <div className='d-flex align-items-center justify-content-center'>
                                                Avaliações
                                            </div>
                                        </th>
                                    </tr>
                                    <tr>
                                        <th rowSpan={2}>
                                            <div className='d-flex align-items-center justify-content-center m-1'>
                                                Indicadores
                                            </div>
                                        </th>
                                        <th rowSpan={2}>
                                            <div className='d-flex align-items-center justify-content-center m-1'>
                                                Qualificação Indicadores
                                            </div>
                                        </th>
                                        <th rowSpan={2}>
                                            <div className='d-flex align-items-center justify-content-center m-1'>
                                                Sub-Índices
                                            </div>
                                        </th>
                                        <th rowSpan={2}>
                                            <div className='d-flex align-items-center justify-content-center m-1'>
                                                Índices
                                            </div>
                                        </th>
                                        <th rowSpan={2} style={{
                                            height: "100%",
                                            backgroundColor: colors[handleIndicadorQualidadeServico(relatorioIQG[0].iqg)],
                                            color: "white"
                                        }}>
                                            <div className='d-flex align-items-center justify-content-center m-1'>
                                                IQG
                                            </div>
                                        </th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {relatorioIQG.length > 0 && relatorioIQG.map((v, index) => {
                                        return <tr className='text-center' key={index}>
                                            {v.quantidadeIndice != null &&
                                                <>
                                                    {/* indices */}
                                                    <td rowSpan={v.quantidadeIndice} colSpan={2}>{v.indice.toUpperCase()}</td>
                                                    <td rowSpan={v.quantidadeIndice}>{v.pesosIndices}</td>
                                                </>
                                            }
                                            {v.quantidadeSubIndice != null &&
                                                <>
                                                    {/* subindices */}
                                                    <td rowSpan={v.quantidadeSubIndice} colSpan={2}>{v.subIndice.toUpperCase()}</td>
                                                    <td rowSpan={v.quantidadeSubIndice}>{v.pesosSubIndices}</td>
                                                </>
                                            }

                                            {/* indicadores */}
                                            <td colSpan={2}>{v.indicadores}</td>
                                            <td >{v.pesosIndicacores}</td>

                                            {/* avaliacoes */}
                                            <td >{v.baseCalculoIndicadores}</td>
                                            <td >{handleIndicadorQualidadeServico(v.baseCalculoIndicadores)}</td>
                                            {v.quantidadeSubIndice != null &&
                                                <>
                                                    {/* subindices */}
                                                    <td rowSpan={v.quantidadeSubIndice}>{v.baseCalculoSubIndice}</td>
                                                </>
                                            }
                                            {v.quantidadeIndice != null &&
                                                <>
                                                    {/* indices */}
                                                    <td rowSpan={v.quantidadeIndice}>{v.baseCalculoIndice.toFixed(2)}</td>
                                                </>
                                            }
                                            {index == 0 &&
                                                <td rowSpan={relatorioIQG.length}
                                                    style={{
                                                        height: "100%",
                                                        backgroundColor: colors[handleIndicadorQualidadeServico(v.iqg)],
                                                        fontWeight: "bold", color: "white"
                                                    }}
                                                >
                                                    {v.iqg.toFixed(2)}
                                                </td>
                                            }
                                        </tr>
                                    })}
                                </tbody>
                                <tfoot>
                                    <tr className='text-center'>
                                        <td colSpan={7} style={{ fontSize: "20px", fontWeight: 400 }}>Qualificação Global da Concessionária</td>
                                        <td colSpan={7} style={{
                                            fontSize: "20px",
                                            background: `${colors[handleIndicadorQualidadeServico(relatorioIQG[0].iqg)]}`,
                                            fontWeight: "bold",
                                            color: "white"
                                        }}
                                        >
                                            {handleIndicadorQualidadeServico(relatorioIQG[0].iqg)}
                                        </td>
                                    </tr>
                                </tfoot>
                            </table>
                        </Col>
                    </Row>
                    <PrintFooter />
                </div>
            }
        </>
    )
})